import { all, call, takeLeading } from 'redux-saga/effects';

import { toPassport, toSsoPassport } from '../index';
import { loadCurrentUser } from './load-current-user';
import { checkForLoginSuccess } from './metrics';
import { toPassportSaga, toSsoPassportSaga } from './toPassport';

/**
 *
 */
export default function* (): Generator {
    yield all([
        call(loadCurrentUser),
        takeLeading(toPassport.type, toPassportSaga),
        takeLeading(toSsoPassport.type, toSsoPassportSaga),
        call(checkForLoginSuccess),
    ]);
}
